export enum EKwikUIInputDateRangeSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputDateRangeSize = [
  EKwikUIInputDateRangeSize.S,
  EKwikUIInputDateRangeSize.M,
  EKwikUIInputDateRangeSize.L
] as const;

export type TKwikUIInputDateRangeSize =
  (typeof VKwikUIInputDateRangeSize)[number];
